import '../js/previewImage.min'

export function previewImg() {
  var $ = {};
  /**
   * get multiple elements
   * @public
   */
  $.all = function (selector, contextElement) {
    var nodeList,
      list = [];
    if (contextElement) {
      nodeList = contextElement.querySelectorAll(selector);
    } else {
      nodeList = document.querySelectorAll(selector);
    }
    if (nodeList && nodeList.length > 0) {
      list = Array.prototype.slice.call(nodeList);
    }
    return list;
  }

  /**
   * delegate an event to a parent element
   * @public
   * @param  array     $el        parent element
   * @param  string    eventType  name of the event
   * @param  string    selector   target's selector
   * @param  function  fn
   */
  $.delegate = function ($el, eventType, selector, fn) {
    if (!$el) {
      return;
    }
    $el.addEventListener(eventType, function (e) {
      var targets = $.all(selector, $el);
      if (!targets) {
        return;
      }
      // findTarget:
      for (var i = 0; i < targets.length; i++) {
        var $node = e.target;
        while ($node) {
          if ($node == targets[i]) {
            fn.call($node, e);
            break; //findTarget;
          }
          $node = $node.parentNode;
          if ($node == $el) {
            break;
          }
        }
      }
    }, false);
  };

  var urls = [];
  // var urls1 = [];
  // var urls2 = [];
  // var urls3 = [];
  // var urls4 = [];
  // var urls5 = [];
  // var urls6 = [];
  // var urls7 = [];
  // var urls8 = [];
  // var urls9 = [];
  // var urls10 = [];
  // var urls11 = [];
  // var urls12 = [];
  // var urls13 = [];
  // var urls14 = [];
  // var urls15 = [];
  // var urls16 = [];
  // var urls17 = [];
  // var urls18 = [];
  // var urls19 = [];
  // var urls20 = [];
  var textImgAll = document.getElementsByClassName('textImg');
  for (var m = 0; m < textImgAll.length; m++) {
    var textImgDom = $.all('.textImg');
    textImgDom.forEach(function (v, i) {
      var imgArr = $.all('img', v);
      imgArr.forEach(function (v1, n) {
        v1.onclick = function (event) {
              var urlL = [];
          $.all('img',textImgDom[i]).forEach(function (v2, m){
                  if (v2.src.indexOf('?imageView2/2/w/720/q/85|imageslim') > -1) {
                    urlL.push(v2.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
                  } else {
                    urlL.push(v2.src)
                  }
                })
          var current = '';
          if (v1.src.indexOf('?imageView2/2/w/720/q/85|imageslim') > -1) {
            current = v1.src.split('?imageView2/2/w/720/q/85|imageslim')[0];
          } else {
            current = v1.src;
          }
          var obj = {
            urls: urlL,
            current: current
          };
          previewImage.start(obj);
        }
      })
    })
  }
  var imgs = $.all('img', $.all('#img_box')[0]);
  imgs.forEach(function (v, i) {
    if (v.src.indexOf('?imageView2/2/w/720/q/85|imageslim') > -1) {
      urls.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
    } else {
      urls.push(v.src)
    }
  })
  $.delegate(document.querySelector('#img_box'), 'click', 'img', function () {
    var current = '';
    if (this.src.indexOf('?imageView2/2/w/720/q/85|imageslim') > -1) {
      current = this.src.split('?imageView2/2/w/720/q/85|imageslim')[0];
    } else {
      current = this.src;
    }
    var obj = {
      urls: urls,
      current: current
    };
    previewImage.start(obj);
  });

  // var imgs1 = $.all('img',$.all('#img_box1')[0]);
  // imgs1.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls1.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls1.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box1'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls1,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });

  // var imgs2 = $.all('img',$.all('#img_box2')[0]);
  // imgs2.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls2.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls2.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box2'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls2,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs3 = $.all('img',$.all('#img_box3')[0]);
  // imgs3.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls3.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls3.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box3'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls3,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  //
  // var imgs4 = $.all('img',$.all('#img_box4')[0]);
  // imgs4.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls4.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls4.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box4'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls4,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs5 = $.all('img',$.all('#img_box5')[0]);
  // imgs5.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls5.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls5.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box5'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls5,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs6 = $.all('img',$.all('#img_box6')[0]);
  // imgs6.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls6.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls6.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box6'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls6,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs7 = $.all('img',$.all('#img_box7')[0]);
  // imgs7.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls7.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls7.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box7'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls7,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs8 = $.all('img',$.all('#img_box8')[0]);
  // imgs8.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls8.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls8.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box8'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls8,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs9 = $.all('img',$.all('#img_box9')[0]);
  // imgs9.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls9.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls9.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box9'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls9,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs10 = $.all('img',$.all('#img_box10')[0]);
  // imgs10.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls10.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls10.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box10'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls10,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs11 = $.all('img',$.all('#img_box11')[0]);
  // imgs11.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls11.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls11.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box11'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls11,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs12 = $.all('img',$.all('#img_box12')[0]);
  // imgs12.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls12.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls12.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box12'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls12,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs13 = $.all('img',$.all('#img_box13')[0]);
  // imgs13.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls13.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls13.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box13'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls13,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs14 = $.all('img',$.all('#img_box14')[0]);
  // imgs14.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls14.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls14.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box14'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls14,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs15 = $.all('img',$.all('#img_box15')[0]);
  // imgs15.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls15.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls15.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box15'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls15,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  // var imgs16 = $.all('img',$.all('#img_box16')[0]);
  // imgs16.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls16.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls16.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box16'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls16,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs17 = $.all('img',$.all('#img_box17')[0]);
  // imgs17.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls17.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls17.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box17'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls17,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs18 = $.all('img',$.all('#img_box18')[0]);
  // imgs18.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls18.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls18.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box18'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls18,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs19 = $.all('img',$.all('#img_box19')[0]);
  // imgs19.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls19.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls19.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box19'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls19,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });
  //
  // var imgs20 = $.all('img',$.all('#img_box20')[0]);
  // imgs20.forEach(function(v,i){
  //   if(v.src.indexOf('?imageView2/2/w/720/q/85|imageslim')>-1){
  //     urls20.push(v.src.split('?imageView2/2/w/720/q/85|imageslim')[0]);
  //   }else {
  //     urls20.push(v.src)
  //   }
  // })
  // $.delegate(document.querySelector('#img_box20'), 'click','img',function(){
  //   var current = this.src;
  //   var obj = {
  //     urls : urls20,
  //     current : current
  //   };
  //   previewImage.start(obj);
  // });

}



// WEBPACK FOOTER //
// ./src/common/js/preview.js